<template>
  <div class="question-form-wrapper">
    <slot name="title"></slot>
    <div class="form-group">
      <b-input
        :class="{ invalid: isEmpty }"
        type="text"
        :placeholder="$t('form_live.tabs.advanced.rich_media.tabs.questions.form.title')"
        v-model="localQuestion.question"
        ref="questionInput"
      ></b-input>
    </div>
    <div class="form-group">
      <b-form-radio-group
        v-model.number="localQuestion.nsp"
        name="radio-options"
        @input="handleUpdateQuestionType"
      >
        <b-form-radio :value="0">{{
          $t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.yes_no')
        }}</b-form-radio>
        <b-form-radio :value="1">{{
          $t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.yes_no_nsp')
        }}</b-form-radio>
        <b-form-radio :value="2">{{
          $t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.simple_choice')
        }}</b-form-radio>
        <b-form-radio :value="3">{{
          $t(
            'form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.multiple_choice',
          )
        }}</b-form-radio>
      </b-form-radio-group>
    </div>
    <div class="answers-wrapper" v-if="localQuestion.nsp > 1">
      <div class="form-group answer-wrapper" v-for="(choice, index) in localQuestion.choices">
        <b-input
          type="text"
          :placeholder="
            $t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.response')
          "
          v-model="choice.response"
        ></b-input>
        <b-button size="sm" class="btn-remove" @click="removeChoice(index)" variant="light">
          <span class="icon-trash"></span>
        </b-button>
      </div>
      <div class="form-group position-relative">
        <b-input
          type="text"
          :placeholder="
            $t('form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.response')
          "
          v-model="newChoice"
          @keyup.enter="addChoice"
        ></b-input>
        <b-button
          size="sm"
          v-show="newChoice"
          @click="addChoice"
          variant="light"
          class="inline-submit-btn"
        >
          <font-awesome-icon icon="plus-circle" />
        </b-button>
      </div>
    </div>
    <b-row>
      <b-col>
        <div class="float-right">
          <b-button variant="secondary" type="button" @click="$emit('closeForm')"
            >{{ $t('button.cancel') }}
          </b-button>

          <b-button variant="primary" type="button" @click="addQuestion" :disabled="!isValid">
            {{ buttonLabel }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UtilsMixin from '../../mixins/UtilsMixin.js';
import i18n from '../../i18n/index.js';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
export default {
  name: 'QuestionForm',
  mixins: [UtilsMixin],
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  data() {
    return {
      newChoice: '',
      localQuestion: {},
    };
  },
  props: {
    question: {
      type: Object,
      default: () => {
        return { question: '', nsp: 0, choices: [] };
      },
    },
    buttonLabel: {
      type: String,
      default: i18n.t(
        'form_live.tabs.advanced.rich_media.tabs.questions.form.local_questions.button_add',
      ),
    },
  },
  computed: {
    isValid() {
      if (!this.localQuestion.question) {
        return false;
      }
      if (this.localQuestion.nsp > 1) {
        return !(this.localQuestion.choices.length === 0 || this.newChoice);
      }
      return true;
    },
    isEmpty() {
      return (
        !this.localQuestion.question &&
        this.localQuestion.choices &&
        this.localQuestion.choices.length > 0
      );
    },
  },
  methods: {
    addQuestion() {
      const question = Object.assign({}, this.localQuestion);
      this.localQuestion = { question: '', nsp: 0, choices: [] };
      this.$emit('addQuestion', question);
    },
    addChoice() {
      if (!this.newChoice) {
        return;
      }
      const choice = {
        response: this.newChoice,
      };
      this.localQuestion.choices.push(choice);
      this.newChoice = '';
    },
    removeChoice(index) {
      this.watchUndoRemoveItem(this.localQuestion.choices, index).then(val => {
        this.localQuestion.choices = val;
      });
      this.localQuestion.choices = this.localQuestion.choices.filter((c, i) => i !== index);
    },
    handleUpdateQuestionType() {
      if (this.localQuestion.nsp < 2) {
        this.localQuestion.type = 'question';
      } else {
        this.localQuestion.type = 'quiz';
      }
    },
  },
  mounted() {
    this.localQuestion = Object.assign({}, this.question);
    this.$nextTick(() => {
      this.$refs.questionInput.$el.focus();

      const questionsWrapper = document.querySelector('.scroll-questions');
      const { top } = questionsWrapper.getBoundingClientRect();
      window.scrollTo(0, top + window.scrollY);
      const editChapterEl = document.querySelector('.chapter-container.question.is-open');
      if (editChapterEl) {
        questionsWrapper.scrollTop = editChapterEl.getBoundingClientRect().top;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import '~styles/theme';
.question-form-wrapper {
  background-color: #f1f3f4;
  padding: 0.8em;
  border-radius: 3px;
  .form-control {
    &.invalid {
      border-color: #dc3545;
    }
  }
  .answers-wrapper {
    .answer-wrapper {
      position: relative;
      &:hover {
        .btn-remove {
          opacity: 1;
          visibility: visible;
        }
      }
      .btn-remove {
        position: absolute;
        right: 0;
        top: 0;
        margin: 3px;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s, visibility 0.2s;
        border-radius: 50%;
      }
    }
  }
  .float-right {
    .btn {
      padding: 0.375rem 1.75rem;
    }
    .btn-primary {
      color: #fff;
      background-color: var(--primary-color, $primary-color) !important;
      border-color: var(--primary-color, $primary-color) !important;
      box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
        0 1px 1px var(--primary-color, $primary-color) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/QuestionForm.vue